/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { TextBlockTypeEnum } from './TextBlockTypeEnum'
import {
  TextBlockTypeEnumFromJSON,
  TextBlockTypeEnumFromJSONTyped,
  TextBlockTypeEnumToJSON,
} from './TextBlockTypeEnum'
import type { FrameTextBlockData } from './FrameTextBlockData'
import {
  FrameTextBlockDataFromJSON,
  FrameTextBlockDataFromJSONTyped,
  FrameTextBlockDataToJSON,
} from './FrameTextBlockData'

/**
 *
 * @export
 * @interface TextBlock
 */
export interface TextBlock {
  /**
   *
   * @type {TextBlockTypeEnum}
   * @memberof TextBlock
   */
  type: TextBlockTypeEnum
  /**
   *
   * @type {FrameTextBlockData}
   * @memberof TextBlock
   */
  data: FrameTextBlockData
}

/**
 * Check if a given object implements the TextBlock interface.
 */
export function instanceOfTextBlock(value: object): value is TextBlock {
  if (!('type' in value) || value['type'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function TextBlockFromJSON(json: any): TextBlock {
  return TextBlockFromJSONTyped(json, false)
}

export function TextBlockFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TextBlock {
  if (json == null) {
    return json
  }
  return {
    type: TextBlockTypeEnumFromJSON(json['type']),
    data: FrameTextBlockDataFromJSON(json['data']),
  }
}

export function TextBlockToJSON(value?: TextBlock | null): any {
  if (value == null) {
    return value
  }
  return {
    type: TextBlockTypeEnumToJSON(value['type']),
    data: FrameTextBlockDataToJSON(value['data']),
  }
}
